module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl20 pr20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("基础信息")]), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "supplier",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.supplier,
      "rules": _vm.rules,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商id:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.supplierId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商编号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.supplierCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.supplierName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对接采销:",
      "prop": "managerUserId"
    }
  }, [_c('el-select', {
    staticClass: "ml_10 vtb",
    attrs: {
      "filterable": "",
      "placeholder": "请选择对接采销"
    },
    model: {
      value: (_vm.supplier.managerUserId),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "managerUserId", $$v)
      },
      expression: "supplier.managerUserId"
    }
  }, _vm._l((_vm.managerUserList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属部门:",
      "prop": "categoryDeptId"
    }
  }, [_c('el-select', {
    staticClass: "ml_10 vtb",
    attrs: {
      "placeholder": "请选择所属部门"
    },
    model: {
      value: (_vm.supplier.categoryDeptId),
      callback: function($$v) {
        _vm.$set(_vm.supplier, "categoryDeptId", $$v)
      },
      expression: "supplier.categoryDeptId"
    }
  }, _vm._l((_vm.deptList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7866a85e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/supplier/supplier_info_edit.vue
// module id = 561
// module chunks = 0